export const defaultHelmVersion = 'v3.7.2'
export const defaultHelmGitCommit = '663a896f4a815053445eec4153677ddc24a0a361'
export const defaultHelmGitTreeState = 'clean'
export const defaultHelmGoVersion = 'go1.17.3'
